import { render, staticRenderFns } from "./ForeignerDetails.vue?vue&type=template&id=64200f52&"
import script from "./ForeignerDetails.vue?vue&type=script&lang=js&"
export * from "./ForeignerDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports